import { render, staticRenderFns } from "./audioPlayer.vue?vue&type=template&id=29284b1a&scoped=true"
import script from "./audioPlayer.vue?vue&type=script&lang=js"
export * from "./audioPlayer.vue?vue&type=script&lang=js"
import style0 from "./audioPlayer.vue?vue&type=style&index=0&id=29284b1a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29284b1a",
  null
  
)

export default component.exports